// Libs
import React from 'react';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow
} from 'react-google-maps';

// Helpers
import TextHelpers from 'helpers/TextHelpers';

// Images
import silhouetteImage from 'images/silhouette.png';

//-------------------------------------------------------------------------------------------------------------------

class Map extends React.Component {

    constructor(props) {
        super(props);
        this.map = null;
        this.state = { };
    }

    resetBounds() {
        const bounds = new window.google.maps.LatLngBounds();
        let hasAnyMarkers = false;
        this.map.props.children.forEach((child) => {
            if (child.type === Marker) {
                bounds.extend(new window.google.maps.LatLng(child.props.position.lat, child.props.position.lng));
                hasAnyMarkers = true;
            }
        })
        if (hasAnyMarkers) {
            this.map.fitBounds(bounds);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.infoWindowCityID != this.state.infoWindowCityID) {
            return true;
        }
        if (nextProps.cities.length != this.props.cities.length) {
            return true;
        }
        for (let i = 0; i < this.props.cities.length; i++) {
            const currentCity = this.props.cities[i];
            const nextCity = nextProps.cities[i];
            if (currentCity.id != nextCity.id) {
                return true;
            }
            if (currentCity.instructors.length != nextCity.instructors.length) {
                return true;
            }
            for (let j = 0; j < currentCity.instructors.length; j++) {
                const currentInstructor = currentCity.instructors[j];
                const nextInstructor = nextCity.instructors[j];
                if (currentInstructor.id != nextInstructor.id) {
                    return true;
                }
            }
        }
        return false;
    }

    componentDidUpdate(oldProps) {
        let resetBounds = false;
        if (oldProps.cities.length != this.props.cities.length) {
            resetBounds = true;
        } else {
            for (let i = 0; i < this.props.cities.length; i++) {
                const currentCity = this.props.cities[i];
                const nextCity = oldProps.cities[i];
                if (currentCity.id != nextCity.id) {
                    resetBounds = true;
                    break;
                }
            }
        }
        if (resetBounds) {
            this.resetBounds();
        }
    }

    render() {
        const {
            infoWindowCityID
        } = this.state;
        const {
            cities
        } = this.props;

        return (
            <GoogleMap
                defaultZoom={8}
                maxZoom={16}
                defaultCenter={{ lat: -34.397, lng: 150.644 }}
                ref={map => {
                    if (!map || this.map) {
                        return;
                    }
                    this.map = map;
                    this.resetBounds();
                }}
            >
                {cities.map(city =>
                    <Marker
                        key={city.id}
                        position={{ lat: city.lat, lng: city.lng }}
                        onClick={e => this.setState({ infoWindowCityID: city.id })}
                    >
                        {infoWindowCityID == city.id &&
                            <InfoWindow onCloseClick={e => this.setState({ infoWindowCityID: null })}>
                                <div>

                                    <ul className="thing-list">
                                        {city.instructors.map(instructor =>
                                            <li key={instructor.id} >

                                                <a
                                                    href={`/instructor/${instructor.slug}`}
                                                    className={`instructor instructor-status-${(instructor.activeStatus || '').toLowerCase()}`}
                                                    target="_blank"
                                                >

                                                    <div className="profile-image" style={{
                                                        backgroundImage: (
                                                            instructor.photoVersion ? `url(/api/instructor/get-photo/${instructor.id}?size=small&version=${instructor.photoVersion})` :
                                                                `url(${silhouetteImage})`
                                                        )
                                                    }} />

                                                    <div className="details">
                                                        <h3>
                                                            {TextHelpers.formatInstructorName(instructor)}
                                                            <div className="tags block">
                                                                {TextHelpers.getInstructorTags(instructor)}
                                                            </div>
                                                        </h3>
                                                        {instructor.city &&
                                                            <p className="detail">
                                                                {instructor.city.name || <>&nbsp;</>}
                                                                {instructor.city.country && instructor.city.country.name && (', ' + instructor.city.country.name)}
                                                            </p>
                                                        }
                                                    </div>

                                                </a>

                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </InfoWindow>
                        }
                    </Marker>
                )}
            </GoogleMap>
        );
    }

}

export default withScriptjs(withGoogleMap(Map));